<template>
  <fade-in-component class="gdcover">
    <h2 class="ttlbar">転職経験者割合</h2>
    <div class="graphdata">
      <h3 class="ttlg01 _trgbtmct">{{secExplain}}</h3>
      <div class="graphcover" id="graphData02">
        <component :is="componentName" :doughnutData="data1" :doughnutData2="data2" :doughnutDataFake="dataF" :doughnutData2Fake="data2F"></component>
      </div>
    </div>
  </fade-in-component>
</template>

<script>
import Doughnut from "../components/Doughnut.vue";
import FadeInComponent from "../components/FadeInComponent.vue";

export default {
  props: ["doughnutData","doughnutDataFake", "doughnutData2","doughnutData2Fake", "explain"],
  components: {
    Doughnut,
    FadeInComponent,
  },
  data() {
    return {
      secExplain: this.explain,
      data1: this.doughnutData,
      data2: this.doughnutData2,
      dataF: this.doughnutDataFake,
      data2F: this.doughnutData2Fake,
      componentName: ""
    };
  },
  methods: {
    handleScroll: function () {
      let targetElement = document.getElementById( "graphData02" ) ;
      let clientRect = targetElement.getBoundingClientRect() ;
      let border = window.pageYOffset + window.innerHeight;
      if (border >= clientRect.top) {
        this.componentName= "Doughnut"
      }else{
        this.componentName= ""
      }
    }    
  }, 
  mounted: function () {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy: function () {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>